"use client";

import { useState } from "react";
import { useTranslations } from "next-intl";

import { Link } from "@/navigation";

const NAMESPACE = "new-fdm-fused-deposition-modeling";

const ITEMS = [
	{ n: 1, defaultOpen: true },
	{ n: 2, defaultOpen: false },
] as const;

export default function FdmSurfaceFinishes() {
	const t = useTranslations(NAMESPACE);
	const [openIndex, setOpenIndex] = useState(0);

	const toggle = (index: number) => {
		setOpenIndex(openIndex === index ? -1 : index);
	};

	return (
		<section className="bg-[#f6f6f6] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<h2 className="mb-6 text-2xl font-bold leading-tight text-black sm:mb-8 sm:text-[30px] md:mb-10 md:text-4xl lg:mb-12">
					{t("fdmSurfaceFinishesTitle")}
				</h2>

				<div className="divide-y divide-gray-200 border-t border-gray-200">
					{ITEMS.map((item, idx) => {
						const isOpen = openIndex === idx;
						return (
							<div key={item.n}>
								<button
									onClick={() => toggle(idx)}
									className="flex w-full items-center justify-between py-5 text-left"
								>
									<span className="text-base font-bold text-black sm:text-lg">
										{t(`fdmSurfaceFinishesItem${item.n}Title` as any)}
									</span>
									<span
										className={`flex h-7 w-7 shrink-0 items-center justify-center ${
											isOpen ? "text-gray-800" : "text-themePrimary400"
										}`}
									>
										<svg
											className={`h-4 w-4 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
											fill="none"
											viewBox="0 0 24 24"
											stroke="currentColor"
											strokeWidth={2.5}
										>
											<path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
										</svg>
									</span>
								</button>

								{isOpen && (
									<div className="pb-6 pr-8">
										<p className="text-sm leading-relaxed text-black md:text-base">
											{t(`fdmSurfaceFinishesItem${item.n}Desc` as any)}
										</p>
									</div>
								)}
							</div>
						);
					})}
				</div>

				<div className="mt-8">
					<Link
						href="/contact-us"
						className="inline-flex items-center justify-center rounded bg-themePrimary400 px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:bg-opacity-80 hover:text-white md:px-8 md:py-3.5 md:text-base"
					>
						{t("fdmSurfaceFinishesContactUs")}
					</Link>
				</div>
			</div>
		</section>
	);
}
